<template>
    <NuxtLayout name="default">
        <SmuError
            :title="title"
            :status-code="error.statusCode"
            :description="errorMessage"
            :info-box-title="description"
            :info-box-description="instruction"
            :action-text="t('helpers.buttons.dashboard')"
            :action="goToDashboard"
        />
    </NuxtLayout>
</template>

<script setup lang="ts">
import { SmuError } from "@smakecloud/smake-ui";
import type { NuxtError } from "nuxt/app";

const { t } = useI18n();

const props = defineProps<{
    error: NuxtError;
}>();

const title = computed(() => {
    if (props.error.statusCode) {
        return t(`errors.${props.error.statusCode}.title`);
    }

    return t(`errors.unknown.title`);
});

const description = computed(() => {
    if (props.error.statusCode) {
        return t(`errors.${props.error.statusCode}.description`);
    }

    return t(`errors.unknown.description`);
});

const instruction = computed(() => {
    if (props.error.statusCode) {
        return t(`errors.${props.error.statusCode}.instruction`);
    }

    return t(`errors.unknown.instruction`);
});

const errorMessage = computed(() => {
    if (props.error.statusCode) {
        return t(`errors.${props.error.statusCode}.message`);
    }

    return t(`errors.unknown.message`);
});

function goToDashboard() {
    navigateTo({
        name: "dashboard",
    });
}
</script>
